export function mask(value: string | undefined, pattern: string) {
    let i = 0;
    if (value === undefined || (value && value === '')) return pattern.replace(/#/g, () => '_');
    //const v = value.split(/\D/).join('');
    const v = value.replace(/[^0-9*]/g, '');
    if (pattern  === undefined) return v;
    return pattern.replace(/#/g, () => v[i++] || '_');
};